(() => {
  'use strict';
  if (window.jykerPreorderInstalled) return;
  window.jykerPreorderInstalled = true;
  const maps = new WeakMap();
  let queued = false;
  const observer = new MutationObserver(schedule);
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(() => { queued = false; refresh(); }, 0);
  }
  function activeFor(id) {
    return [...document.querySelectorAll('[data-jyker-variant]')].some(x => x.dataset.jykerVariant === String(id) && x.dataset.active === 'true');
  }
  window.jykerPreorderProperties = id => activeFor(id) ? { properties: { 'Purchase type': 'Pre-order', 'Estimated shipping': 'Ships in about 4-6 weeks' } } : {};
  function refresh() {
    observer.disconnect();
    try {
      document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
        const state = form.querySelector('.jyker-preorder-state');
        const source = state?.querySelector('[data-jyker-variants]');
        const input = form.querySelector('input[name="id"]');
        if (!state || !source || !input) return;
        let variants = maps.get(source);
        if (!variants) { try { variants = JSON.parse(source.textContent); maps.set(source, variants); } catch { return; } }
        const active = variants[input.value]?.active === true;
        state.dataset.active = String(active);
        state.querySelectorAll('[data-jyker-property]').forEach(x => x.remove());
        if (active) {
          Object.entries({ 'Purchase type': 'Pre-order', 'Estimated shipping': 'Ships in about 4-6 weeks' }).forEach(([key, value]) => {
            const prop = document.createElement('input');
            prop.type = 'hidden'; prop.name = 'properties[' + key + ']'; prop.value = value; prop.dataset.jykerProperty = 'true'; state.append(prop);
          });
        }
      });
    } finally {
      observer.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled']});
    }
  }
  document.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('submit', event => {
    if (event.target.matches?.('form[data-type="add-to-cart-form"]')) refresh();
  }, true);
  refresh();
})();
